<template>
  <div class="tab-content scroll-container">
    <div v-if="errorLogs.length">
        <div class="parent-container" v-for="(errorLog,index) in errorLogs " :key="errorLog.id">
            <div role="tab">
                <h5 class="panel-title">
                    <a :class="{'collapsed': errorLog.number_of_children > 0 && errorLog.collapsed}"
                       @click="errorLog.number_of_children > 0 && getChildren(errorLog);"
                       :data-toggle="errorLog.number_of_children > 0 ? 'collapse' : null"
                       :href="errorLog.number_of_children > 0 ? '#child' + index : null"
                       :aria-expanded="errorLog.number_of_children > 0 ? 'false' : null"
                       :aria-controls="errorLog.number_of_children > 0 ? 'child' + index : null" v-html="errorLog.text">
                    </a>

                </h5>
            </div>
            <div  v-show="errorLog.children && errorLog.children.length > 0"  :id="'child' + index"  class="panel-collapse collapse" role="tabpanel">
                <div class="panel-body" v-for="(errorLogChildren,counter) in errorLog.children" :key="counter">
                    <span v-html="errorLogChildren.text"> </span>
                </div>
            </div>
        </div>
        <!-- Display "Load More" button if there are more logs to load -->
        <div v-if="hasMoreLogs && !isLoading" class="row load-more-button">
          <button class="btn btn-default" @click="loadMoreLogs">Load More</button>
        </div>
        <!-- Display a message when there are no more logs to load -->
        <div v-if="!hasMoreLogs && !isLoading" class="no-more-logs">
          No more errors to load.
        </div>
        <div v-if="isLoading" class="row">
          <div class="col-md-6 col-md-offset-5">
            <img src="/pic/loading-4.gif">
          </div>
        </div>
    </div>
    <div v-else>
      <div class="inquiry-no-result">
        <br/>
        <h3 class="font-bold"><span class="fa fa-ban"></span> There are no error logs</h3>
      </div>
    </div>
  </div>
</template>
<script>

import {EventBus} from "@/events/event-bus";
import axios from "axios";

export default {
  name: "ErrorLogs",
  props: {
    errorLogsData: {
      type: Array,
      required: true,
      default: () => []
    },
    apiName: {
      type: String
    },
    table:{
      type: String
    }
  },
  data() {
    return {
      errorLogs: [],
      currentPage: 2,
      perPage: 2,
      hasMoreLogs: true,
      isLoading: false,
    };
  },
  methods:{
      getChildren(errorLog){
        errorLog.collapsed = !errorLog.collapsed;
          if(!errorLog.childrenFetched){
            let id = errorLog.id;
            let url = `/${this.apiName}/history/${id}`;
            axios.get(url).then(response => {
                if( response && response.data.childrenHistory){
                  let index = this.errorLogs.findIndex(item => item.id === id);
                  if (index !== -1) {
                    // Use Vue.set or this.$set to ensure reactivity
                    this.$set(this.errorLogs[index], 'children', response.data.childrenHistory);
                    this.$set(this.errorLogs[index], 'childrenFetched', true);
                  }
                }
            });
          }
      },
      loadMoreLogs() {
        this.isLoading = true;
        const params = {
          table: this.table,
          page_number: this.currentPage,
          fromVueJs: true,
        };

        let url = `/${this.apiName}/view-errors`;
        axios.get(url, {params: params})
            .then((response) => {
              const newLogs = response.data.msg;
              if (newLogs.length > 0) {
                this.errorLogs = [...this.errorLogs, ...newLogs];
                this.currentPage += 1;
                this.hasMoreLogs = newLogs.length === this.perPage;
              } else {
                this.hasMoreLogs = false;
              }
            })
            .catch((error) => {
              console.error("Error loading call logs: ", error);
            })
            .finally(() => {
              this.isLoading = false;
            });
      },
      handleScroll: _.debounce(function() {
        // Check if the user has scrolled to the bottom of the page or container
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;

        if (bottomOfWindow && this.hasMoreLogs && !this.isLoading) {
          this.loadMoreLogs();
        }
      }, 300),
  },
  mounted() {
    this.errorLogs = this.errorLogsData
    // Attach the scroll event listener to the window or a specific scrollable container
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('scroll', this.handleScroll);
  },

};
</script>

<style scoped>
.tab-content{
  padding: 20px;
}
.parent-container {
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #EAECEE;
}
.panel-body{
  border-radius: 12px;
  border: 1px solid #EAECEE;
  margin-top: 12px;
  background-color: #F5F5F6;
}
.children{
  background-color: #FFFFFF;
}
.panel-title > a.collapsed:before {
  float: left !important;
  content: "\f067";
}
.panel-title > a:before {
  float: left !important;
  font-family: FontAwesome;
  content: "\f068";
  padding-right: 5px;
}
.load-more-button,.no-more-logs{
  text-align: center;
}
</style>